import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/cn';
import { STATUS_COLORS, PRIORITY_COLORS } from '@/lib/constants';

interface StatusBadgeProps {
  status: string;
  type: 'lead' | 'deal' | 'task' | 'expense' | 'invoice' | 'quotation' | 'agreement' | 'priority';
  className?: string;
}

export function StatusBadge({ status, type, className }: StatusBadgeProps) {
  let colorClass = '';

  if (type === 'priority') {
    colorClass = PRIORITY_COLORS[status as keyof typeof PRIORITY_COLORS] || '';
  } else {
    const statusMap = STATUS_COLORS[type as keyof typeof STATUS_COLORS];
    if (statusMap) {
      colorClass = (statusMap as Record<string, string>)[status] || '';
    }
  }

  const displayLabel = (status || '').replace(/_/g, ' ');

  return (
    <Badge variant="outline" className={cn('border-0 font-medium', colorClass, className)}>
      {displayLabel}
    </Badge>
  );
}
